/**
 * A board's colour (owner, 13.10.2026): the stored value is a CSS background,
 * normally `linear-gradient(135deg, <from>, <to>)`, drawn as-is by every
 * client (tiles, recent strip, rows, Android, web).
 *
 * The NEUTRAL preset is stored as a real dark gradient, so other clients draw
 * it as it is. This app recognises the exact value and swaps it for a light
 * gradient with dark text in light mode (`boards-tile--neutral`, CSS only), so
 * the preset reads as "dark card in dark mode, light card in light mode".
 */
export const NEUTRAL_BOARD_COLOR = 'linear-gradient(135deg, #2a2a30 0%, #18181b 100%)';

export const isNeutralBoardColor = (color) => String(color || '').replace(/\s+/g, '') === NEUTRAL_BOARD_COLOR.replace(/\s+/g, '');

const HEX = /#(?:[0-9a-f]{3}){1,2}\b/gi;

/** "#abc" → "#aabbcc", lower case; anything else → null. */
export function normalizeHex(value) {
  const m = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(String(value || '').trim());
  if (!m) return null;
  const h = m[1].length === 3 ? m[1].split('').map((c) => c + c).join('') : m[1];
  return `#${h.toLowerCase()}`;
}

/** The first and last colour of a stored board colour, for the two editors on
 *  the colour bar. A single colour is both ends; nothing usable → the default. */
export function gradientStops(color, fallback = ['#2563eb', '#9333ea']) {
  const hexes = (String(color || '').match(HEX) || []).map(normalizeHex).filter(Boolean);
  if (!hexes.length) return fallback;
  return [hexes[0], hexes[hexes.length - 1]];
}

/** The stored value for two chosen colours — the same shape as the presets. */
export function gradientFrom(from, to) {
  return `linear-gradient(135deg, ${normalizeHex(from) || '#2563eb'} 0%, ${normalizeHex(to) || '#9333ea'} 100%)`;
}
